<template>
  <tr>
    <th scope="row">
      <router-link :to="{ name: 'DeviceInfo', params: { deviceId: detector.identifier }, query: { showHomeLink: '1' } }">{{ detector.identifier }}</router-link>
    </th>
    <td>{{ detector.Locality }}</td>
    <td>{{ detector.DESCRIPTION }}</td>
    <td class="text-lowercase">{{ currentStateFormated }}</td>
    <td class="text-nowrap"><span v-html="lastUpdateFormated"></span></td>
    <td class="text-nowrap"><span v-html="lastContactFormated"></span></td>
    <td>{{ detector.LastContactState }}</td>
    <td>{{ detector.SignalLevel }}</td>
    <td>
      <div class="text-end"><button @click="openForm" type="button" class="btn btn-secondary"><i class="fa-solid fa-envelope"></i></button></div>
    </td>
  </tr>
</template>


<script setup>
import {defineProps, defineEmits, computed} from "vue";
import { formatDate, formatState } from "@/utils/format";

const emit = defineEmits(["openDetectorForm"]);

const props = defineProps({
  detector: {
    type: Object,
    required: true,
    default() {
      return {
        identifier: -1,
        Locality: '',
        DESCRIPTION: '',
        currentstate: '',
        lastUpdate: '',
      }
    }
  }
});

const openForm = () => {
  emit("openDetectorForm", props.detector.identifier);
};

const lastUpdateFormated = computed(() => formatDate(props.detector.LastUpdate, '<br>'));
const lastContactFormated = computed(() => formatDate(props.detector.LastContact, '<br>'));
const currentStateFormated = computed(() => formatState(props.detector.currentstate));

</script>


<style scoped>
</style>
